'use client';

import { HorizontalEventCard } from '@goodneighbor/ui';
import styles from './registrationComplete.module.scss';
import { parseForEventCardProps } from '@/services/event';
import { Event } from '@goodneighbor/api/schemas/events/event.schema';
import CancellationCard from '../CancellationCard';

export default function RegistrationComplete({
  event,
  organizationName
}: {
  event: Event;
  organizationName: string;
}) {
  return (
    <div className={styles.registrationComplete}>
      <img
        src="/placeholder/celebration.svg"
        className={styles.image}
        aria-hidden
        alt=""
      />
      <p className={styles.text}>Registration complete. You&apos;re in!</p>
      <HorizontalEventCard
        {...parseForEventCardProps(event, organizationName)}
      />
      <CancellationCard />
    </div>
  );
}
